import { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import Get from "../../../api/Get";
import { GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN, SCHEDULE_DINAMIC_BY_SPECIALITY } from "../../../api/Routes";
import { getTokenExternal } from "../../../utils/getTokenExternal";
import Post from "../../../api/Post";
import moment from "moment";
import Loading from "../Loading";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useWalmartUrl } from "../../../utils/walmartUrl";

export default function MexEspecialidad({classTop='', data, setData, setCurrentScreen}){
    const { isWalmart, specialityId } = useWalmartUrl()
    const [especialidad, setEspecialidad] = useState(null)
    const [fecha, setFecha] = useState(new Date())
    const [especialidadesOpt, setEspecialidadesOpt] = useState([])
    const [selectedIndexTime, setSelectedIndexTime] = useState(-1)
    const [startDay, setStartDay] = useState(0)
    const [specialtyError, setSpecialtyError] = useState(null)
    const [items, setItems] = useState({
        data: null,
        loading: false,
        fetched: false,
        error: false
    })
    const hideSpecialtySelect = isWalmart && Boolean(specialityId)

    useEffect(() => {
        const fetchApi = async () => {
            try {
                const response = await Get({url: `${GET_SPECIALITY_BY_ACCOUNT_SIN_TOKEN}/${data.patient.account.id}`, noToken: true})
                if(response.data.state){
                    const options = response.data.data.response.map(item=>({label: item.name, value:item.id}))
                    setEspecialidadesOpt(options)

                    if (isWalmart && specialityId) {
                        const match = options.find(opt => String(opt.value) === String(specialityId))
                        if (match) {
                            setSpecialtyError(null)
                            setEspecialidad(match)
                        } else {
                            setSpecialtyError("La especialidad indicada no está disponible para esta cuenta.")
                            setEspecialidad(null)
                        }
                    }
                }else{
                    setEspecialidadesOpt([])
                    if (isWalmart && specialityId) {
                        setSpecialtyError("La especialidad indicada no está disponible para esta cuenta.")
                    }
                }
            } catch (error) {
                setEspecialidadesOpt([])
                if (isWalmart && specialityId) {
                    setSpecialtyError("La especialidad indicada no está disponible para esta cuenta.")
                }
                console.log(error)
            }
        }
        fetchApi()
    }, [isWalmart, specialityId, data.patient.account.id])

    //get ls horarios disponibles por especialidad y fecha
    useEffect(() => {
        if(especialidad){
            setItems({
                data: null,
                loading: true,
                fetched: true,
                error: false
            })
            const fetchHorarios = async () => {
                try {
                    const responseToken = await getTokenExternal()
                    const token = responseToken.data.access_token                    
                    //horarios
                    let url = `${SCHEDULE_DINAMIC_BY_SPECIALITY}?specialityId=${especialidad.value}&dateIni=${moment(fecha).format("DD-MM-YYYY")}&dateEnd=${moment(fecha).format("DD-MM-YYYY")}&accountId=${data.patient.account.id}&link=${data.linkAllianz}`
                    const response = await Post({url: url, data:{}, access_token: token, header: true});
                    if(response.data.state){
                        if(Object.keys(response.data.data.response).length > 0){                    
                            let keys = Object.keys(response.data.data.response)
                            let obj = {
                                key: keys[0],
                                value: response.data.data.response[keys[0]]
                            }    
                            setItems(prev=>({
                                ...prev,
                                data: obj,
                                loading: false,
                            }))            
                        }else{
                            let obj = {
                                key: moment(fecha).format("YYYY-MM-DD"),
                                value: []
                            }
                            setItems(prev=>({
                                ...prev,
                                data: obj,
                                loading: false,
                            })) 
                        }  
                    }
                } catch (error) {
                    setItems(prev=>({
                        ...prev,
                        data: null,
                        loading: false,
                        error: true
                    })) 
                }
            }
            fetchHorarios()
        }
    }, [especialidad, fecha])

    const minusDay = n =>{
        let nDays = startDay-n
        setStartDay(nDays) 
        let newFecha = moment(fecha)
        newFecha.subtract(n, 'days')    
        setFecha(newFecha)    
        setSelectedIndexTime(null)             
    }

    const plusDay = n =>{
        let nDays = startDay+n
        setStartDay(nDays)        
        let newFecha = moment(fecha)
        newFecha.add(n, 'days')    
        setFecha(newFecha)   
        setSelectedIndexTime(null)    
    }

    const selectTime = (it, i) =>{
        setSelectedIndexTime(i)
        let schedule = {
            scheduleType:"Online",
            doctor:null,
            hourInit: moment(it.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss"),
            candidateDoctors: it.doctors.map(e=>e.id) 
        }
        setData(prev=>({
            ...prev,
            hourInit: moment(it.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY HH:mm:ss"),
            schedule: schedule,
            doctorName: ``,
            especialidadName: especialidad.label,
            especialidadId: especialidad.value
        }))
    }

    const dateComponent = (extraClasses = '') => (
        items.data ? 
        <div className={`d-flex align-items-center ${extraClasses}`}>
            <div className="mr-3">
                {startDay > 0 && <span className="bg-arrow" onClick={e=>minusDay(1)}><BsChevronLeft /></span>}
            </div>
            <div className="mr-3">
                <div className="text-center">
                    <span className="d-block colorLabel fw-medium">{moment(items.data.key, "YYYY-MM-DD").format("ddd")}</span>
                    <span className="colorLabel">{moment(items.data.key, "YYYY-MM-DD").format("DD MMM YYYY")}</span>                    
                </div>
            </div>
            <div className="mr-3">{startDay !== 7 && <span className="bg-arrow" onClick={e=>plusDay(1)}><BsChevronRight /></span>}</div>
        </div>: null
    )

    return (
        <Row className={classTop}>
             <Col xs="12" md={{span: 10, offset: 1}}>
                <Card className='mt-2 mb-5 shadow-sm'>
                    <Card.Body className="p-5">
                        <h5 className="colorLink mb-4 text-center">Próximas citas disponibles el día de hoy</h5>                        
                        <div className="my-3 text-center">
                            <Row>
                                <Col xs="12" md={{span: 6, offset: 3}}>
                                    {hideSpecialtySelect ? (
                                        especialidad && (
                                            <>
                                                <Form.Label className="fw-medium colorLink mb-3">Especialidad</Form.Label>
                                                <p className="colorLabel fw-medium mb-0">{especialidad.label}</p>
                                            </>
                                        )
                                    ) : (
                                        <>
                                            <Form.Label className="fw-medium colorLink mb-3">Elige la especialidad</Form.Label>
                                            <Select
                                                options={especialidadesOpt}
                                                value={especialidad}
                                                onChange={(value)=>setEspecialidad(value)}
                                                placeholder="Selecciona una opción"
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                      ...baseStyles,
                                                      height: '34px',
                                                    }),
                                                  }}
                                            />
                                        </>
                                    )}
                                    {specialtyError && (
                                        <div className="invalid-feedback d-block mt-2">{specialtyError}</div>
                                    )}
                                </Col>
                            </Row>
                        </div>

                        {items.fetched &&
                        <div className="mt-4 mb-5">
                            { items.loading && <div className="py-3 text-center"><Loading /></div>}
                            {
                                (!items.loading && items.error) &&
                                <div className="py-3 text-center text-danger"><span>No esposible obtener los horarios intenta nuevamente.</span></div>
                            }
                            {
                                (!items.loading && !items.error && items.data.value.length === 0) &&
                                <div>
                                    {dateComponent("justify-content-center")}
                                    <div className="py-3 text-center colorLink"><span>No hay horarios disponibles para la fecha seleccionada</span></div>
                                </div>
                                
                            }
                            {
                                (!items.loading && !items.error && items.data.value.length > 0) &&
                                <div>
                                    <span className="colorLabel fw-medium d-block mt-5 mb-2">Elige el horario de tu preferencia:</span>
                                    {dateComponent('')}
                                    <div className="d-flex flex-wrap justify-content-start py-3">
                                        {
                                            items.data.value.map((item, idx) => (
                                                <span 
                                                    key={`time-${idx}`}
                                                    className={`${selectedIndexTime === idx ? 'box-time-active' : ''} box-time colorLink fw-medium m-1`}
                                                    onClick={() => selectTime(item, idx)}
                                                >{moment(item.hour, "HH:mm:ss").format("HH:mm")}</span>
                                            ))
                                        }
                                    </div>
                                </div> 
                            }                           
                        </div>}

                        <hr className="mb-5" style={{borderWidth: '3px', borderColor: '#0000001A', width: '40%', margin: 'auto'}}/>
                           
                        
                        <div className="d-flex justify-content-center mt-2 mb-4">
                            {!isWalmart && (
                                <button
                                    className="mr-2"
                                    onClick={()=>setCurrentScreen("mexFormPatient")}
                                >
                                    Regresar
                                </button>
                            )}
                            <button
                                disabled={selectedIndexTime<0}
                                onClick={()=>setCurrentScreen("confirmarServicio")}
                            >
                                Continuar
                            </button>
                        </div>
                         
                    </Card.Body>
                </Card>
             </Col>
        </Row>
    )
}
